<template>
	<div>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<v-card-text v-else-if="isBlocked !== null">
			<v-skeleton-loader style="max-width: 555px" v-bind="attrs" type="card" v-if="isLoading">
			</v-skeleton-loader>
			<div
				v-if="!isLoading && uploads.length > 0"
				v-for="attachment in uploads"
				:key="uploads.id"
				class="mt-1"
			>
				<FileListComponent :attachment="attachment" />
			</div>
			<div v-if="!isLoading && isCurrentPageListEmpty" class="mt-5 align-center">
				<NewsFeedEmpty
					title="Action resources is empty at the moment."
					description="Check back later."
				/>
			</div>
			<div
				class="d-flex my-9 ma-auto justify-center home-page__pagination"
				v-if="!isLoading && uploads.length > 0"
			>
				<Pagination
					:page="filters.page"
					:pageCount="pageCount"
					v-on:pageChange="onPageChange"
				/>
			</div>
		</v-card-text>
		<v-dialog
			class="exhibitor-page__modal"
			v-model="showErrorDialog"
			max-width="588px"
			width="100%"
			persistent
		>
			<v-card class="exhibitor-page__modal">
				<div class="exhibitor-page__modal__title">This Content is not available</div>
				<button type="button" class="exhibitor-page__modal__btn" @click="handleDialogOk">
					OK
				</button>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'
import Pagination from '@/components/Pagination.vue'
import ButtonBack from '@/components/ButtonBack.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import Dwh from '@/mixins/Dwh'
import Filter from '@/mixins/Filter'
import FileListComponent from '@/components/FileListComponent.vue'

export default {
	name: 'ActionResourcePage',
	mixins: [Block, Dwh, Filter],
	components: {
		NewsFeedEmpty,
		Pagination,
		ButtonBack,
		PageBlocked,
		FileListComponent,
	},
	computed: {
		...mapGetters('resources', ['resourcesList', 'listMeta']),
		...mapGetters('event', ['actionFiles', 'actionFilesMeta', 'isLoading', 'event']),
		...mapGetters('auth', ['profile']),
		eventInfo() {
			return this.getBlockData('eventInfo', {})
		},
		currentUser() {
			return this.profile
		},

		uploads() {
			if (!this.actionFiles && this.actionFiles.length > 0) {
				return []
			}
			return this.actionFiles
		},
		isCurrentPageListEmpty() {
			const isFilesEmpty = this.uploads.length <= 0
			return isFilesEmpty
		},
		pageCount() {
			if (this.actionFilesMeta && this.uploads.length > 0) {
				return +this.actionFilesMeta.pageCount
			}

			return 0
		},
		pageTitle() {
			return this.$route.query.title || null
		},
	},
	methods: {
		...mapActions('event', ['getActionLinks', 'getActionFiles', 'getEvent']),
		...mapActions('app', ['setPageTitle']),
		async fetchSource() {
			if (this.$route.query.source === 'session') {
				return
			}
			this.showErrorDialog = false
			const idEvent = +this.$route.params.eventId
			if (!idEvent || isNaN(idEvent)) {
				this.showErrorDialog = true
				return
			}
			try {
				await this.getEvent(idEvent)
				const eventChapterId = this.eventInfo.chapter.chapter_id
				if (typeof eventChapterId !== 'number') {
					this.showErrorDialog = true
					return
				}
				const userChapters = (this.currentUser?.chapters || []).map((c) => +c.chapter_id)
				console.log('userChapters', userChapters)
				console.log('eventChapterId', eventChapterId)
				const hasAccess = eventChapterId === 0 || userChapters.includes(eventChapterId)
				if (!hasAccess) {
					this.showErrorDialog = true
				}
			} catch (e) {
				console.error(e)
				this.showErrorDialog = true
			}
		},
		getBlockData(name, fallback = undefined) {
			const block = (this.event.eventView || []).find((b) => b.block_name === name)
			return block ? block.block_data : fallback
		},
		handleDialogOk() {
			this.showErrorDialog = false
			this.toggleToEventList()
		},
		toggleToEventList() {
			this.$router.push({ name: 'events' })
		},
		getResources(queryString) {
			this.getActionFiles({ id: this.$route.params.actionId, queryString })
		},
	},
	watch: {
		uploads(newValue) {
			if (newValue.length) {
				const triggerPayload = {
					category: 'Content',
					action: 'view_action_list_of_files_event',
					module: 'Events',
					content_chapter_id:
						this.event && this.event.chapter_id ? [this.event.chapter_id] : null,
				}
				if (this.$route.query.title) {
					triggerPayload.title = this.$route.query.title
				}
				this.sendTrigger(triggerPayload)
			}
		},
	},
	data() {
		return {
			showErrorDialog: false,
			successMessage: false,
			errorMessage: false,
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			pageBlockedName: 'events',
		}
	},
	async created() {
		if (
			this.$route.params.eventId !== undefined &&
			this.$route.params.actionId !== undefined &&
			(!this.isBlocked || this.isBlocked === null)
		) {
			await this.getActionFiles(this.requestQuery)
			await this.fetchSource()
		}
	},
	mounted() {
		this.setPageTitle(this.pageTitle)
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
}
</script>

<style lang="scss"></style>
